import { render, staticRenderFns } from "./GradeControl.vue?vue&type=template&id=15b24ab1&scoped=true&"
import script from "./GradeControl.vue?vue&type=script&lang=js&"
export * from "./GradeControl.vue?vue&type=script&lang=js&"
import style0 from "./GradeControl.vue?vue&type=style&index=0&id=15b24ab1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b24ab1",
  null
  
)

export default component.exports